var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 8,
    viewBox: "0 0 6 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333496 0.419601C0.333496 0.119058 0.70936 -0.116208 0.979705 0.0612617C2.83144 1.27907 3.61078 2.41685 5.46182 3.63466C5.73286 3.81281 5.7363 4.17387 5.46527 4.35202C3.61354 5.56983 2.84661 6.71184 0.994188 7.92965C0.858325 8.01941 0.725221 8.01601 0.617635 7.96025C0.461772 7.90993 0.333496 7.77258 0.333496 7.54548L0.333496 0.419601Z",
    fill: "#F7931A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.bd6f1c01ec7f851f38a388a92d33a721.svg";
export { ForwardRef as ReactComponent };